export default {"src":"/_next/static/media/show-live-icon.ac6d2a7c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};